import type { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_FEATURE_HINT_DISMISS_REASON = {
  GotIt: "got_it",
  LearnMore: "learn_more",
  Close: "close",
  /** The user clicked the anchored element itself, i.e. used the feature. */
  Anchor: "anchor",
} as const;

export type DSFeatureHintDismissReason = ObjectValues<typeof DS_FEATURE_HINT_DISMISS_REASON>;

export interface DSFeatureHintEmits {
  (e: "dismiss", reason: DSFeatureHintDismissReason): void;
  (e: "anchor-missing"): void;
}

export type DSFeatureHintCardDismissReason =
  | typeof DS_FEATURE_HINT_DISMISS_REASON.GotIt
  | typeof DS_FEATURE_HINT_DISMISS_REASON.LearnMore;

export interface DSFeatureHintCardEmits {
  (e: "dismiss", reason: DSFeatureHintCardDismissReason): void;
}
